var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "activities-listing-table__container" },
    [
      _vm.isTableLoading ? _c("TableLoading") : _vm._e(),
      _vm._v(" "),
      _vm.shouldDisplayEmptyState
        ? _c(
            "CompassEmptyState",
            _vm._b(
              { staticClass: "activities-listing__empty-state" },
              "CompassEmptyState",
              _vm.emptyStateDatas,
              false
            ),
            [
              !_vm.isEqual(_vm.defaultFilters, _vm.filters)
                ? _c("CompassButton", {
                    attrs: { label: _vm.localizedTexts.labelResetFiltersBtn },
                    on: { click: _vm.resetFilters }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "CompassTable",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.shouldDisplayTable,
              expression: "shouldDisplayTable"
            }
          ],
          ref: "activitiesListingTable",
          staticClass: "activities-listing-table",
          class: _vm.tableClasses,
          attrs: {
            size: _vm.sizeTable,
            border: _vm.isActivityPage,
            isCheckable: _vm.shouldDisplayMassActionsCheckbox,
            checkedRows: _vm.idsSelectedActivities
          },
          on: {
            "update:checkedRows": function(rows) {
              return (_vm.idsSelectedActivities = rows)
            }
          }
        },
        [
          _c(
            "CompassTableHead",
            { attrs: { isFixed: "" }, on: { sort: _vm.handleSort } },
            [
              _vm._l(_vm.getColumns, function(column) {
                return _c(
                  "CompassTableHeadCell",
                  {
                    key: column.code,
                    class: column.customClass,
                    attrs: {
                      sortable: _vm.sortable[column.sortKey],
                      fixed: column.fixed
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(column.label) +
                        "\n            "
                    )
                  ]
                )
              }),
              _vm._v(" "),
              _c("CompassTableHeadCell", {
                staticClass: "activities-listing__cell-actions",
                attrs: { fixed: "right" }
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "CompassTableBody",
            {
              ref: "activitiesTableBody",
              class: { "reschedule-menu--is-open": !_vm.enableRowNativeEvents }
            },
            _vm._l(_vm.activities, function(activity) {
              return _c("ActivitiesListingTableRow", {
                key: activity.id,
                ref: "activity-row-" + activity.id,
                refInFor: true,
                attrs: {
                  columns: _vm.getColumns,
                  activity: activity,
                  sizeTable: _vm.sizeTable,
                  isActivityPage: _vm.isActivityPage,
                  isHovered: _vm.hoveredRow === activity.id,
                  widthActionsCol: _vm.widthActionsCol
                },
                on: {
                  updateStatus: _vm.updateStatus,
                  updatePriority: _vm.updatePriority,
                  enableRowNativeEvents: _vm.toggleEnableRowNativeEvents,
                  "update:widthActionsCol": function(newWidthActionsCol) {
                    return (_vm.widthActionsCol = newWidthActionsCol)
                  }
                },
                nativeOn: {
                  click: function($event) {
                    return (function(event) {
                      return _vm.onClickItem(activity, event)
                    })($event)
                  }
                }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.filters.completed && _vm.isActivityPage
        ? _c("ActivitiesListingMassActions", {
            attrs: {
              selectedActivities: _vm.selectedActivities,
              isToolbarVisible: !!_vm.idsSelectedActivities.length,
              workingDays: _vm.metas.working_days
            },
            on: { closeToolbar: _vm.clearSelectedActivities }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }